export class AuthenticateRequestModel{
    userName:string = '';
    password:string='';
    domainName:string = '';
}
